"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pasteHandler = exports.Link = void 0;
const extension_link_1 = require("@tiptap/extension-link");
const state_1 = require("@tiptap/pm/state");
const linkifyjs_1 = require("linkifyjs");
const plugin_1 = require("./utils/plugin");
const handlePasteLinkPluginKey = 'handlePasteLink';
exports.Link = extension_link_1.Link.extend({
    addCommands() {
        const commands = this.parent?.() ?? {};
        return {
            ...commands,
            setLink: (attributes) => ({ chain }) => {
                const link = parseLink(attributes.href, this.options.defaultProtocol);
                return chain()
                    .extendMarkRange(this.type)
                    .setMark(this.name, link ? { ...attributes, href: link.href } : attributes)
                    .setMeta('preventAutolink', true)
                    .run();
            },
        };
    },
    addProseMirrorPlugins() {
        const plugins = this.parent?.() ?? [];
        if (this.options.linkOnPaste) {
            const isPluginInstanceOfHandlePasteLinkPluginKey = (0, plugin_1.createPluginKeyChecker)(handlePasteLinkPluginKey);
            const index = plugins.findIndex(isPluginInstanceOfHandlePasteLinkPluginKey);
            if (!index) {
                throw new Error('Failed to replace handlePasteLinkPlugin');
            }
            plugins.splice(index, 1, pasteHandler({
                editor: this.editor,
                defaultProtocol: this.options.defaultProtocol,
                type: this.type,
            }));
        }
        return plugins;
    },
});
function pasteHandler(options) {
    return new state_1.Plugin({
        key: new state_1.PluginKey(handlePasteLinkPluginKey),
        props: {
            handlePaste: (view, event, slice) => {
                const { state } = view;
                const { selection } = state;
                const { empty } = selection;
                if (empty) {
                    return false;
                }
                let textContent = '';
                slice.content.forEach((node) => {
                    textContent += node.textContent;
                });
                const link = parseLink(textContent, options.defaultProtocol);
                if (!textContent || !link) {
                    return false;
                }
                if (options.editor.isActive('link')) {
                    options.editor
                        .chain()
                        .extendMarkRange(options.type)
                        .updateAttributes(options.type, {
                        href: link.href,
                    })
                        .run();
                }
                else {
                    options.editor.commands.setMark(options.type, {
                        href: link.href,
                    });
                }
                return true;
            },
        },
    });
}
exports.pasteHandler = pasteHandler;
function parseLink(href, defaultProtocol) {
    return (0, linkifyjs_1.find)(href, { defaultProtocol: defaultProtocol }).find((item) => item.isLink && item.value === href);
}
//# sourceMappingURL=link.js.map